import { render, staticRenderFns } from "./PurchasedRecordView.vue?vue&type=template&id=cf5104aa&scoped=true"
import script from "./PurchasedRecordView.vue?vue&type=script&lang=js"
export * from "./PurchasedRecordView.vue?vue&type=script&lang=js"
import style0 from "./PurchasedRecordView.vue?vue&type=style&index=0&id=cf5104aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5104aa",
  null
  
)

export default component.exports